"use client";

import React from "react";
import { Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="215187" className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 animate-pulse rounded-md bg-muted" />)}
      </div>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-muted-foreground transition-colors hover:text-accent-foreground">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  return <section id="footer" className="relative w-full !opacity-[1] !bg-[hsl(0,0%,100%)] !text-[hsl(0,0%,100%)]">
      <div className="h-1 w-full bg-primary/20" />

      <div className="mx-auto max-w-7xl px-4 py-12 md:px-8 lg:py-16">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-3 md:gap-8">
          <div className="flex flex-col items-start gap-6">
            <Link to="/">
              <img src="https://trusty-molly.10web.cloud/wp-content/uploads/2026/04/cropped-2.png" alt="Connected Online Logo" className="h-8 w-auto object-contain" />
            </Link>
            <p className="max-w-xs text-sm leading-relaxed text-muted-foreground font-sans">Online verbonden. Wij helpen ondernemers groeien met slimme AI-tools en echte persoonlijke aandacht.</p>
          </div>

          <div className="flex flex-col gap-6">
            <h3 className="font-default text-lg font-semibold tracking-tight text-primary">
              Navigatie
            </h3>
            <MenuProvider menu_id="38">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          <div className="flex flex-col gap-6">
            <h3 className="font-default text-lg font-semibold tracking-tight text-primary">
              Contact
            </h3>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3 text-sm text-muted-foreground font-sans">
                <MapPin className="size-5 shrink-0 text-accent-foreground" />
                <span>Haarlemmermeer based, overal online</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground font-sans">
                <Phone className="size-5 shrink-0 text-accent-foreground" />
                <Link to="tel:+31101234567" className="transition-colors hover:text-accent-foreground">+31 (6) 40 25 51 26</Link>
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground font-sans">
                <Mail className="size-5 shrink-0 text-accent-foreground" />
                <Link to="mailto:hello@connectedonline.nl" className="transition-colors hover:text-accent-foreground">
                  hello@connectedonline.nl
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-6 border-t border-border/50 pt-8 md:mt-16 md:flex-row md:gap-4">
          <p className="text-center text-xs text-muted-foreground md:text-left font-mono">
            &copy; {new Date().getFullYear()} Connected Online.
            Data Driven, Human Centered.
          </p>
          <Badge variant="outline" className="border-accent-foreground/30 bg-accent/5 text-accent-foreground hover:bg-accent/10 font-mono">
            Logic & Love
          </Badge>
          <div className="flex gap-4">
            <Link to="/algemene-voorwaarden" className="text-xs text-muted-foreground transition-colors hover:text-accent-foreground font-mono">
              Algemene Voorwaarden
            </Link>
            <Link to="/privacy-beleid" className="text-xs text-muted-foreground transition-colors hover:text-accent-foreground font-mono">
              Privacybeleid
            </Link>
          </div>
        </div>
      </div>
    </section>;
}